"use client";

import { authLogin } from "@/entities";
import { useMutation } from "@tanstack/react-query";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";

export function LoginPage() {
  const router = useRouter();

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const loginMutation = useMutation({
    mutationFn: authLogin,
    onSuccess: () => {
      window.location.href = "/app/main";
      // router.push("/app/main");
    },
    onError: (e: any) => {
      toast.error(`에러(${e.message})가 발생했습니다. 다시 시도해 주세요.`);
    },
  });

  const onSubmit = async (data: any) => {
    if (loginMutation.isPending) return;
    await loginMutation.mutateAsync(data);
  };

  return (
    <>
      <div className="login login-v1">
        <div className="login-container">
          <div className="login-header">
            <div className="brand">
              <div className="d-flex align-items-center">로그인</div>
              <small>계정에 로그인하려면 아래에 이메일을 입력하세요.</small>
            </div>
            <div className="icon">
              <i className="fa fa-lock"></i>
            </div>
          </div>
          <div className="login-body">
            <div className="login-content fs-13px">
              <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "이메일을 입력해주세요.",
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <>
                      <div className="form-floating mb-20px">
                        <input
                          type="email"
                          id="email"
                          title="이메일을 입력해주세요."
                          placeholder="이메일을 입력해주세요."
                          className="form-control fs-13px h-45px"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value || ""}
                        />
                        <label
                          htmlFor="email"
                          className="d-flex align-items-center py-0"
                        >
                          이메일
                        </label>
                        {errors.email && (
                          <span className="text-red errorText">
                            {errors.email.message as string}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                />

                <Controller
                  name="password"
                  control={control}
                  rules={{
                    required: "비밀번호를 입력해주세요.",
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <>
                      <div className="form-floating mb-20px">
                        <input
                          type="password"
                          id="password"
                          title="비밀번호를 입력해주세요."
                          placeholder="비밀번호를 입력해주세요."
                          className="form-control fs-13px h-45px"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value || ""}
                        />
                        <label
                          htmlFor="email"
                          className="d-flex align-items-center py-0"
                        >
                          비밀번호
                        </label>
                        {errors.password && (
                          <span className="text-red errorText">
                            {errors.password.message as string}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                />

                <div className="login-buttons mb-15px">
                  <button
                    type="submit"
                    className="btn h-45px btn-theme d-block w-100 btn-lg"
                    disabled={loginMutation.isPending}
                  >
                    로그인
                  </button>
                </div>

                {/* <div className="mb-6 mt-6 flex items-center justify-center">
                  <div className="h-px w-full bg-gray" />
                  <span className="text-sm text-gray-9 font-normal mx-4">
                    or
                  </span>
                  <div className="h-px w-full bg-gray" />
                </div>

                <div className="login-buttons mb-15px">
                  <button
                    className="btn h-45px btn-yellow d-block w-100 btn-lg flex items-center justify-center"
                    disabled={loginMutation.isPending}
                  >
                    <RiKakaoTalkFill className="absolute w-6 h-6" />
                    카카오 로그인
                  </button>
                </div> */}

                <div className="d-flex justify-content-between">
                  <div>
                    계정이 없으신가요?{" "}
                    <Link
                      href="/auth/signup"
                      className="text-white text-decoration-none fw-bold"
                    >
                      가입하세요
                    </Link>
                  </div>
                  <div>
                    <Link
                      href="/auth/forgot-password"
                      className="text-white text-decoration-none fw-bold"
                    >
                      비밀번호를 잊으셨나요?
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div id="footer" className="app-footer text-center">
            &copy; 2025 wezoncoop. All Right Reserved
          </div>
        </div>
      </div>
    </>
  );
}
